import { ACTIONS } from '../actions';

const INITIAL_STATE = {
  userRoles: [],
};

export function allUserRoles (state = INITIAL_STATE, action) {
  switch (action.type) {
    case ACTIONS.GET_ALL_USER_ROLES:
      return { ...state, userRoles: action.payload.data };
    default:
      return state;
  }
}

const INITIAL_STATE_ROLES = {
  userRoles: [],
  userRolesAccess: {
    type: 'default',
    roles: '',
    user_access: {
      type: {
        value: 'default',
        label: 'Use default setting',
      },
      users: '',
    },
  },
};

export function userRolesAccess (state = INITIAL_STATE_ROLES, action) {
  switch (action.type) {
    case ACTIONS.GET_USER_ROLES_IP_BLOCK:
      if (action.payload.data && action.payload.data.type) {
        return { ...state, userRolesAccess: action.payload.data };
      }

      return state;
    default:
      return state;
  }
}

export function allRolesSetting (state = INITIAL_STATE_ROLES, action) {
  switch (action.type) {
    case ACTIONS.GET_IP_BLOCK_SETTING:
      let roles = {
        file_access_permission: '',
        whitelist_roles: '',
      };
      if (action.payload.data && action.payload.data.file_access_permission) {
        roles = action.payload.data;
      }
      return { ...state, roles };
    default:
      return state;
  }
}

const INITIAL_STATE_MEMBERS = {
  members: [
    {
      user_access_manager: '',
      memberships_2: '',
      paid_memberships_pro: '',
      woo_memberships: '',
      woo_subscriptions: '',
      ar_member: '',
    }],
  noMember: true,
};

export function membersSelect (state = INITIAL_STATE_MEMBERS, action) {
  switch (action.type) {
    case ACTIONS.GET_MEMBERS_SELECT:
      if (action.payload.data.length === 0) {
        return INITIAL_STATE_MEMBERS;
      }
      return { ...state, members: action.payload.data, noMember: false };
    default:
      return state;
  }
}
